import React from 'react';
import { useTheme } from 'styled-components';

const ShieldIcon = ({ size = 16, color, ...props }) => {
  const theme = useTheme();
  const iconStroke = color || (theme?.dark ? 'white' : 'currentColor');
  return(
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99343 1.4968L3.66677 2.74346C2.9001 3.03013 2.27344 3.93679 2.27344 4.75679V9.71012C2.27344 10.4968 2.79344 11.5301 3.42678 12.0035L6.29344 14.1435C7.23344 14.8501 8.78009 14.8501 9.72009 14.1435L12.5868 12.0035C13.2201 11.5301 13.7401 10.4968 13.7401 9.71012V4.75679C13.7401 3.93679 13.1134 3.03013 12.3468 2.74346L9.0201 1.4968C8.45343 1.29013 7.54676 1.29013 6.99343 1.4968Z"
      stroke={iconStroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00045 7.29004C7.97378 7.29004 7.94044 7.29004 7.91378 7.29004C7.28711 7.27004 6.78711 6.75003 6.78711 6.1167C6.78711 5.47003 7.31378 4.94336 7.96045 4.94336C8.60712 4.94336 9.13379 5.47003 9.13379 6.1167C9.12712 6.7567 8.62711 7.27004 8.00045 7.29004Z"
      stroke={iconStroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.67336 9.15675C6.03336 9.58341 6.03336 10.2834 6.67336 10.7101C7.40003 11.1967 8.59336 11.1967 9.32003 10.7101C9.96003 10.2834 9.96003 9.58341 9.32003 9.15675C8.60003 8.67008 7.40669 8.67008 6.67336 9.15675Z"
      stroke={iconStroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)};

export default ShieldIcon;
